import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import ApplicationStep from "./ApplicationStep";
import ApplicationSummary from "./ApplySteps/ApplicationSummary";
import { useEffect, useState, useMemo, useRef } from "react";
import { useUserData } from "../UserDataContext";
import { useJobs } from "../jobsContext";
import Rive from "@rive-app/react-canvas";
import Confetti from "react-confetti";
import { db, increment, auth } from "../firebase";
import { useUsermaven } from "../UserMaven";
let applicationFormData = {
  title: "Your Application",
  steps: [{
    id: "1",
    title: "General Information",
    sections: [{
      id: "generalInfo",
      title: "Review Your Information",
      subTitle: "This is your basic information from your profile.",
      questions: [{
        index: "wrangle_general_fullname",
        label: "Full Name",
        type: "text",
        required: false,
        regexp: "^[a-zA-Z]+[-' ]+[a-zA-Z]+$"
      }, {
        index: "wrangle_general_email",
        label: "Email",
        type: "text",
        required: false,
        regexp: "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])"
      }, {
        index: "wrangle_general_phone",
        label: "Phone",
        type: "text",
        required: false,
        regexp: "^(?=([+()\\d\\s-]*\\d){10,})[+\\d()\\s-]*$"
      }, {
        index: "wrangle_general_address",
        label: "Address",
        type: "text",
        required: false,
        regexp: ""
        // countryOptions: [
        //   { value: "United States", label: "United States" },
        //   { value: "Mexico", label: "Mexico" },
        // ],
      }]
    }]
  }, {
    id: "2",
    title: "Your Documents",
    sections: [{
      id: "resume",
      label: "Resume",
      subTitle: "Be sure to include an updated resume",
      questions: [{
        index: "resumeFile",
        type: "file",
        options: [{
          index: "res_1",
          format: "PDF",
          filename: "",
          lastUsed: new Date(2024, 1, 1)
        }, {
          index: "res_2",
          format: "PDF",
          filename: "f"
          //lastUsed: new Date(2024, 3, 1),
        }]
      }]
    }
    // {
    //   id: "coverLetter",
    //   label: "Cover letter",
    //   subTitle: "Select or upload a cover letter for this role",
    //   questions: [
    //     {
    //       id: "coverLetterFile",
    //       type: "file",
    //       options: [
    //         {
    //           id: "1",
    //           format: "PDF",
    //           filename: "",
    //           lastUsed: new Date(2024, 2, 1),
    //         },
    //       ],
    //     },
    //   ],
    // },
    ]
  }, {
    id: "3",
    title: "Written Questions",
    sections: [{
      id: "requiredQuestions",
      title: "Required Questions",
      subTitle: "These questions are mandatory for your application to be submitted",
      questions: []
    }, {
      id: "notRequiredQuestions",
      title: "Not Required",
      subTitle: "These questions aren't essential, but may impact your odds of being hired",
      questions: [{
        id: "2weeksAvail",
        type: "select",
        label: "Are you available to start within 2 weeks?",
        required: true,
        options: [{
          label: "Yes",
          value: "Yes"
        }, {
          label: "No",
          value: "No"
        }]
      }]
    }]
  }]
};
const listOptionsJSON = jsonInp => {
  if (jsonInp && Array.isArray(jsonInp)) {
    const optionsArray = jsonInp.map(item => ({
      id: item.label.id,
      text: item.label.text
    }));
    return optionsArray;
  }
  return null;
};
const AppModal = ({
  isOpen,
  onCloseApp,
  inpLink,
  company,
  guid,
  companyName,
  title,
  htmlId
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [applicationFormValue, setApplicationFormValue] = useState({});
  let appLink = inpLink;
  const ignoredSelectors = {};
  const [formInfo, setFormInfo] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const {
    user,
    userData,
    setUserData,
    currentApi,
    isAuthenticated
  } = useUserData();
  const {
    selectedJob,
    setBannerMessage,
    setBannerType
  } = useJobs();
  const [fetched, setFetched] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isFormReady, setIsFormReady] = useState(false);
  const [newApp, setNewApp] = useState(false);
  const [errored, setErrored] = useState(false);
  const [jsonSuccess, setJsonSuccess] = useState(true);
  const scrollContainerRef = useRef(null);
  const modalRef = useRef();
  const currentJobOutRef = useRef();
  const hashCode = s => s.split("").reduce((a, b) => (a << 5) - a + b.charCodeAt(0) | 0, 0);
  let usermavenOpts = {
    key: "UMWZUKUs0g",
    tracking_host: "https://events.usermaven.com"
  };
  const {
    usermaven
  } = useUsermaven(usermavenOpts);
  const handleClose = param => {
    if (!param) {
      usermaven.track("Application Modal Closed", {
        uid: user?.uid,
        name: userData?.name,
        email: userData?.email,
        address: userData?.address,
        //appsUsed: appsUsed,
        salary: userData?.keywords?.salary,
        seniority: userData?.keywords?.seniority,
        title: userData?.keywords?.title,
        jobId: guid
      });
    }
    onCloseApp();
    resetModalState();
  };
  const resetModalState = () => {
    setFormInfo([]);
    setInputValues({});
    setFetched(false);
    setShowButton(true);
    setShowSuccess(false);
    setIsFormReady(false);
    setNewApp(false);
    setErrored(false);
    setCurrentStep(1);
  };
  const getFormHtml = async () => {
    //console.log(guid);
    //console.log(appLink);
    //console.log(htmlId)
    let idToken;
    if (auth.currentUser) {
      idToken = await auth.currentUser.getIdToken(true);
    } else {
      return;
    }
    const response = await fetch(`${currentApi}/get-form-workday`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`
      },
      body: JSON.stringify({
        id: guid
      })
    });
    if (!response.ok) {
      setErrored(true);
      throw new Error(`Error response from server: ${response.status}`);
    }
    const {
      formInfo,
      link
    } = await response.json();
    appLink = link;
    return formInfo;
  };
  const getFormNormal = async () => {
    let idToken;
    if (auth.currentUser) {
      idToken = await auth.currentUser.getIdToken(true);
    } else {
      return;
    }
    const response = await fetch(`${currentApi}/get-form`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`
      },
      body: JSON.stringify({
        appLink: appLink,
        guid: hashCode(guid).toString()
      })
    });
    if (!response.ok) {
      setErrored(true);
      throw new Error(`Error response from server: ${response.status}`);
    }
    const {
      formInfo
    } = await response.json();
    return formInfo;
  };
  const fetchFormInfo = async () => {
    setErrored(false);
    try {
      let formInfo;
      if (htmlId) {
        //formInfo = await getFormHtml();
        formInfo = await getFormHtml();
      } else {
        formInfo = await getFormNormal();
      }
      for (let i = 0; i < formInfo.length; i++) {
        formInfo[i].index = formInfo[i].label;
        if (formInfo[i].label.toLowerCase().includes("cover letter")) {
          formInfo[i].index = "coverLetter";
        }
      }
      //console.log(formInfo);
      if (!formInfo || formInfo.length === 0) {
        console.error("Form information is empty.");
        setErrored(true);
        return;
      }
      const prompt = formInfo.filter(({
        type,
        label
      }) => type !== "file" && type !== "Divider").map(({
        selector,
        options,
        label,
        type,
        tag,
        required
      }) => {
        const typeOrTag = type || tag || "Unknown";
        const requiredText = required ? "Required" : "Not required";
        // Check if options is an array and map over it, else return an empty string
        const optionsText = Array.isArray(options) ? "|" + options.map(opt => opt.label).join(",") : "";
        return `${label}|${typeOrTag}|${requiredText}${optionsText}`;
      }).join("\n");
      try {
        let {
          parsedAnswers,
          jobIdentifier
        } = await openAIWhisper(prompt);
        if (!parsedAnswers) {
          parsedAnswers = [];
        }
        //let parsedAnswers = [];
        //let jobIdentifier = currentJobOutRef.current;
        if (jobIdentifier == currentJobOutRef.current) {
          for (let i = 0; i < formInfo.length; i++) {
            // check for toggles
            if (!formInfo[i].options && formInfo[i].type == "checkbox" && (!parsedAnswers[formInfo[i].label] || parsedAnswers[formInfo[i].label] != "true" || parsedAnswers[formInfo[i].label] != "false")) {
              if (formInfo[i].selector == '[name="cards[1511a958-cba8-4266-8468-abdd3e0d8d9b][field7]"]' || formInfo[i].selector == `[name="cards[498867a3-ab6c-4c28-b022-50da44067fa7][field6"]` || formInfo[i].selector == `[name="cards[498867a3-ab6c-4c28-b022-50da44067fa7][field10]"]` || formInfo[i].selector == `[set="23662402002"]` || formInfo[i].label.includes("acknowledge") || formInfo[i].label.includes("Acknowledge")) {
                parsedAnswers[formInfo[i].label] = "true";
              } else {
                parsedAnswers[formInfo[i].label] = "false";
                formInfo[i].type = "toggle";
                formInfo[i].tag = "toggle";
                if (parsedAnswers[formInfo[i]] == "yes") {
                  parsedAnswers[formInfo[i]] = "true";
                }
                if (parsedAnswers[formInfo[i]] != "true") {
                  parsedAnswers[formInfo[i]] = "false";
                }
              }
            }
          }
          //console.log(parsedAnswers)
          console.log(formInfo);
          formInfo = formInfo.filter(item => item.type !== "file" && item.label && item.label != "Divider" && !((item.selector == '[name="cards[1511a958-cba8-4266-8468-abdd3e0d8d9b][field7]"]' || item.selector == `[name="cards[498867a3-ab6c-4c28-b022-50da44067fa7][field6"]` || item.selector == `[name="cards[498867a3-ab6c-4c28-b022-50da44067fa7][field10]"]` || item.selector == `[set="23662402002"]` || item.label.includes("acknowledge") || item.label.includes("Acknowledge")) && item.type == "checkbox" && !item.options) && !(item.label == "Demographics (Select all that Apply)" ||
          //item.label.includes("pronouns") ||
          //item.label.includes("Pronouns") ||
          item.label == "Custom")).map(item => {
            //Step 2: Map over the filtered results
            const options = item.options?.map(option => ({
              label: option.label || option.value,
              // Use label if available, otherwise use value
              value: option.value
            })) || []; // Ensure options is an array, even if item.options is undefined
            const parsedOptions = item.jsonOptions ? listOptionsJSON(item.jsonOptions) : null;
            if (parsedOptions) item.required = true;
            return {
              ...item,
              // Spread the rest of the item's properties
              options,
              // Overwrite the options property with the transformed options array
              parsedOptions
            };
          });
          applicationFormData.steps[2].sections[0].questions = formInfo.filter(item => item.required == true);
          applicationFormData.steps[2].sections[1].questions = formInfo.filter(item => item.required != true);
          const userResumeData = userData.resumeData ? [...userData.resumeData] : [];
          let validResumes = [{
            index: "res_1",
            format: userData.filename.split(".").pop().toUpperCase(),
            filename: userData.filename,
            title: userData.filename
          }];
          if (userData.allResumes) {
            for (let i = 0; i < userData.allResumes?.length; i++) {
              let fname = userData.allResumes[i];
              const isFilenameExists = validResumes.some(resume => resume.filename === fname);
              if (!isFilenameExists) {
                const matchingResume = userResumeData.find(resume => resume.id === fname.split(".")[0]);
                validResumes.push({
                  index: `res_${i + 2}`,
                  // Adjusting index to start from res_1 instead of res_0
                  format: fname.split(".").pop().toUpperCase(),
                  filename: fname,
                  title: matchingResume ? matchingResume.title : fname
                });
              }
            }
          }
          applicationFormData.steps[1].sections[0].questions[0].options = validResumes;
          //console.log(validResumes);
          //[
          // {
          //   index: "res_1",
          //   format: userData.filename.split(".").pop().toUpperCase(),
          //   filename: userData.filename,
          // },
          validResumes;
          //];
          parsedAnswers["wrangle_general_fullname"] = userData.name;
          parsedAnswers["wrangle_general_email"] = userData.email;
          parsedAnswers["wrangle_general_address"] = userData.address;
          parsedAnswers["wrangle_general_phone"] = userData.phone;
          parsedAnswers["resumeFile"] = "res_1";
          for (let p = 0; p < formInfo.length; p++) {
            //console.log(parsedAnswers[formInfo[p]]);
            //console.log(formInfo[p]);
            if (formInfo[p].options && formInfo[p].options.length > 0 && formInfo[p].tag == "select") {
              //console.log(parsedAnswers[formInfo[p].label]);
              //console.log(formInfo[p].options);
              if (parsedAnswers[formInfo[p].label]) {
                const matchingOption = formInfo[p].options.find(option => {
                  return option.label === parsedAnswers[formInfo[p].label] || option.value === parsedAnswers[formInfo[p].label];
                });
                //console.log(matchingOption);
                if (matchingOption) {
                  parsedAnswers[formInfo[p].label] = matchingOption.value;
                } else {
                  delete parsedAnswers[formInfo[p].label];
                }
              }
            }
          }

          //console.log(applicationFormData);
          //console.log(parsedAnswers);
          setInputValues(parsedAnswers);
          setFormInfo(formInfo);
          if (formInfo.some(info => info.jsonOptions !== undefined)) {
            setJsonSuccess(false);
          }
          console.log(formInfo);
          setFetched(true);
          setNewApp(true);
        }
      } catch (error) {
        console.error("Error while calling OpenAI Whisper API:", error);
        setErrored(true);
      }
    } catch (error) {
      console.error("Error while fetching form information:", error);
      setErrored(true);
    }
  };
  useEffect(() => {
    if (isOpen) {
      resetModalState();
      fetchFormInfo();
    } else {
      resetModalState();
    }
  }, [isOpen, appLink]);
  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [currentStep]);
  const Loader = () => <Rive src="/wrangleloading.riv" className="w-[400px] h-[400px] min-w-[400px] min-h-[400px]"></Rive>;
  const Success = () => <Rive src="/success.riv" className="min-w-[250px] min-h-[250px] w-[250px] h-[250px]"></Rive>;
  const openAIWhisper = questions => {
    return new Promise(async (resolve, reject) => {
      if (questions.length === 0) {
        //console.log('Form info is empty. Not calling OpenAI Whisper API');
        resolve([]);
        return;
      }
      try {
        currentJobOutRef.current = hashCode(guid).toString();
        let idToken;
        if (auth.currentUser) {
          idToken = await auth.currentUser.getIdToken(true);
        } else {
          return;
        }
        const response = await fetch(`${currentApi}/ai-request`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`
          },
          body: JSON.stringify({
            questions: questions,
            userData: {
              Address: userData.address,
              Portfolio: userData.portfolio,
              Phone: userData.phone,
              Name: userData.name,
              Keyinfo: userData.keyInfo,
              Filename: userData.filename,
              Email: userData.email,
              linkedin: userData.linkedin ? "https://linkedin.com/in/" + userData.linkedin : "",
              figma: userData.figma ? "https://figma.com/@" + userData.figma : "",
              dribbble: userData.dribbble ? "https://dribbble.com/" + userData.dribbble : "",
              github: userData.github ? "https://github.com/" + userData.github : "",
              twitter: userData.twitter ? "https://twitter.com/" + userData.twitter : "",
              stackoverflow: userData.stackoverflow ? "https://stackoverflow.com/users/" + userData.stackoverflow : ""
            },
            selectedJob: {
              companyName: companyName,
              title: title
            },
            jobIdentifier: hashCode(guid).toString()
          })
        });
        if (!response.ok) {
          console.error("Error while fetching from OpenAI Whisper API");
          setErrored(true);
          resolve([]);
        }
        const {
          parsedAnswers,
          jobIdentifier
        } = await response.json();
        resolve({
          parsedAnswers,
          jobIdentifier
        });
      } catch (error) {
        console.error("Error while calling OpenAI Whisper API:", error);
        setErrored(true);
        resolve([]);
      }
    });
  };
  useEffect(() => {
    const requiredFields = formInfo.filter(info => info.required && info.type !== "file");
    const allRequiredFieldsFilled = requiredFields.every(field => {
      if (field.options && field.options.length > 0) {
        //const validOptions = field.options.map((option) => option.value);
        if (Array.isArray(inputValues[field.label])) {
          // return (
          //   inputValues[field.label].length > 0 &&
          //   inputValues[field.label].every((value) =>
          //     validOptions.includes(value)
          //   )
          // );
          return inputValues[field.label].length > 0;
        } else {
          return (
            //validOptions.includes(inputValues[field.label]) &&
            inputValues[field.label] != null && inputValues[field.label] != "" && !["Please Select", "Please select", "---", "--", ""].includes(inputValues[field.label])
          );
        }
      }
      if (field.type == "checkbox") {
        return true;
      }
      return !!inputValues[field.label];
    });
    const unansweredRequiredFields = requiredFields.filter(field => {
      if (field.options) {
        //const validOptions = field.options.map((option) => option.value);
        if (Array.isArray(inputValues[field.label])) {
          // return !(
          //   inputValues[field.label].length > 0 &&
          //   inputValues[field.label].every((value) =>
          //     validOptions.includes(value)
          //   )
          // );
        } else {
          return (
            //!validOptions.includes(inputValues[field.label]) ||
            !["Please Select", "Please select", "---", "--", ""].includes(inputValues[field.label])
          );
        }
      }
      return !inputValues[field.label];
    });
    setIsFormReady(allRequiredFieldsFilled);
  }, [inputValues]);
  const handleSubmit = async () => {
    usermaven.track("Application Submitted", {
      uid: user?.uid,
      name: userData?.name,
      email: userData?.email,
      address: userData?.address,
      //appsUsed: appsUsed,
      salary: userData?.keywords?.salary,
      seniority: userData?.keywords?.seniority,
      title: userData?.keywords?.title,
      jobId: guid
    });
    const jobRef = htmlId ? guid : hashCode(guid).toString();
    //const jobRef = hashCode(guid).toString();
    const userId = user.uid;
    setShowSuccess(true);
    setShowButton(false);
    setTimeout(async () => {
      handleClose();
      setNewApp(false);
      setUserData(prevUserData => ({
        ...prevUserData,
        applied: [...(prevUserData.applied || []), guid]
      }));
      let updatedFormInfo = formInfo.map(input => {
        const newValue = inputValues[input.label] || input.value;
        const {
          required,
          ...inputWithoutRequiredOrOptions
        } = input;
        if (input.selector.includes("gdpr")) {
          return {
            ...inputWithoutRequiredOrOptions,
            value: newValue || input.value,
            type: "checkbox",
            // Set type to checkbox for GDPR fields
            tag: "input" // Set tag to input for GDPR fields
          };
        }
        let updatedType = input.type;
        if (input.tag === "select" && !input.type) {
          updatedType = "dropdown";
        }
        return {
          ...inputWithoutRequiredOrOptions,
          value: newValue || input.value,
          type: updatedType // Use the updated tag
        };
      });
      // Define the Resume/CV input field
      const resumeInputField = {
        label: "Resume/CV",
        required: false,
        tag: "input",
        type: "file",
        selector: '[data-field="resume"]'
      };

      // Insert the Resume/CV field at the beginning of the updatedFormInfo array using splice
      updatedFormInfo.splice(0, 0, resumeInputField);
      try {
        /*console.log({
          url: appLink,
          inputs: updatedFormInfo,
          profileId: userId,
          jobId: jobRef,
          coverLetter: inputValues["coverLetter"] || "",
        });
        console.log(
          JSON.stringify({
            applications: [
              {
                address: userData.address,
                url: appLink,
                inputs: updatedFormInfo,
                profileId: userId,
                filename:
                  applicationFormData.steps[1].sections[0].questions[0].options.find(
                    (option) => option.index === inputValues["resumeFile"]
                  )?.filename || userData.filename,
                jobId: jobRef,
                coverLetter: inputValues["coverLetter"] || "",
              },
            ],
          })
        );*/
        if (!htmlId) {
          let idToken;
          if (auth.currentUser) {
            idToken = await auth.currentUser.getIdToken(true);
          } else {
            return;
          }
          const response = await fetch(`${currentApi}/apply`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify({
              applications: [{
                address: userData.address,
                url: appLink,
                inputs: updatedFormInfo,
                profileId: userId,
                filename: applicationFormData.steps[1].sections[0].questions[0].options.find(option => option.index === inputValues["resumeFile"])?.filename || userData.filename,
                jobId: jobRef,
                coverLetter: inputValues["coverLetter"] || ""
              }]
            })
          });
          if (response.ok) {
            setBannerMessage("Update: Request sent to server.");
            setBannerType("update");
          } else {
            setBannerMessage("Error: Error with submission.");
            setBannerType("error");
            console.error("Error while submitting the job application");
          }
        } else {
          const response = await fetch(`${currentApi}/api-apply-workday`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer wrangle-test`
            },
            body: JSON.stringify({
              application: {
                inputs: updatedFormInfo,
                profileId: "LURq7VVIz9ZqhJKcOMyn",
                jobId: jobRef
              }
            })
          });
          if (response.ok) {
            setBannerMessage("Update: Request sent to server.");
            setBannerType("update");
          } else {
            setBannerMessage("Error: Error with submission.");
            setBannerType("error");
            console.error("Error while submitting the job application");
          }
        }
      } catch (error) {
        setBannerMessage("Error: Error with submission.");
        setBannerType("error");
        console.error("Error:", error);
      }
    }, 3000);
  };
  const stepLabelColor = stepNumber => {
    return currentStep == stepNumber ? "text-primary-600 font-semibold" : "text-primary-600";
  };
  const nextStep = () => setCurrentStep(currentStep + 1);
  const prevStep = () => setCurrentStep(currentStep - 1);
  return <AnimatePresence mode="wait">
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-[2px] z-40 overflow-y-auto no-scrollbar">
          <div className="flex items-center justify-center min-h-screen px-4">
            <AnimatePresence>
              <motion.div transition={{
            duration: 0.5,
            ease: "easeInOut"
          }} className="bg-white rounded-lg shadow-sm mx-auto flex flex-col" initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} exit={{
            scale: 0.9,
            opacity: 0
          }} style={{
            width: errored || !fetched ? "400px" : "720px",
            maxHeight: "80vh"
          }}>
                {errored ? <div className="p-4 shadow-[0px_20px_24px_-4px_rgba(16,_24,_40,_0.08),_0px_8px_8px_-4px_rgba(16,_24,_40,_0.03)] bg-base-white rounded-beast">
                    <div className="relative w-full overflow-hidden flex flex-col items-start justify-start text-left text-lg text-gray-900 font-text-sm-semibold rounded-beast">
                      <div className="self-stretch flex-1 flex flex-col items-start justify-start gap-[48px] rounded-b-lg">
                        <div className="self-stretch flex flex-col items-start justify-start gap-[24px]">
                          <div className="self-stretch flex flex-col items-start justify-start gap-[2px]">
                            <div className="self-stretch relative leading-[28px] font-semibold">
                              Whoops! Something went wrong.
                            </div>
                            <div className="self-stretch relative text-base leading-[24px] text-gray-600">
                              It looks like this job is either expired, or the
                              application exceeded the models context length.
                            </div>
                          </div>
                          <div className="self-stretch py-12 flex flex-col items-center justify-center">
                            <img className="relative w-[390px] h-[258px] object-cover" alt="" src="/error.png" />
                          </div>
                        </div>
                        <div className="self-stretch flex flex-row items-start justify-center gap-[12px] text-sm text-gray-700">
                          <div className="flex-1 rounded-lg bg-base-white hover:bg-neutral-50 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-4 items-center justify-center border-[1px] border-solid border-gray-300 cursor-pointer" onClick={() => {
                      handleClose();
                      setErrored(false);
                    }}>
                            <div className="relative leading-[20px] font-semibold">
                              Go Back
                            </div>
                          </div>
                          <div className="flex-1 rounded-lg bg-mediumseagreen-100 shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row py-2.5 px-4 items-center justify-center text-base-white border-[1px] border-solid border-mediumseagreen-100 cursor-pointer" onClick={() => {
                      handleClose();
                      setErrored(false);
                      setUserData(prevUserData => ({
                        ...prevUserData,
                        applied: [...(prevUserData.applied || []), guid]
                      }));
                      resetModalState();
                    }}>
                            <div className="relative leading-[20px] font-semibold">
                              Hide Job
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> : showSuccess ? <div className="flex items-center justify-center h-[400px] w-[400px] min-h-[400px] min-w-[100%]">
                    <Success />
                  </div> : <>
                    <div>
                      {fetched ? <>
                          <div className="px-6 py-4 bg-luh-gray border-b border-neutral-700 box-border border-solid flex justify-between items-center rounded-t-lg max-h-[80%] min-h-50vh">
                            <div className="text-base font-semibold text-primary-600">
                              {`Application to ${companyName}`}
                            </div>
                            <motion.svg whileHover={{
                      scale: 1.1
                    }} whileTap={{
                      scale: 0.9
                    }} onClick={handleClose} xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="#808080">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                            </motion.svg>
                          </div>

                          <div className="flex items-center justify-center px-12 my-3">
                            <div className="relative w-full" style={{
                      height: "20px"
                    }}>
                              <AnimatePresence>
                                {currentStep !== applicationFormData.steps.length + 1 ? <motion.div key="stepLabels" initial={{
                          opacity: 0,
                          x: -10
                        }} animate={{
                          opacity: 1,
                          x: 0
                        }} exit={{
                          opacity: 0,
                          x: -10
                        }} transition={{
                          duration: 0.5
                        }} className="absolute inset-0 flex justify-between text-sm">
                                    {applicationFormData.steps.map((step, idx) => <span className={`mx-4 ${stepLabelColor(idx + 1)}`} key={`application-step-title-${idx}`}>
                                          {step.title}
                                        </span>)}
                                  </motion.div> : <motion.div key="reviewLabel" initial={{
                          opacity: 0,
                          x: 10
                        }} animate={{
                          opacity: 1,
                          x: 0
                        }} exit={{
                          opacity: 0,
                          x: 10
                        }} transition={{
                          duration: 0.5
                        }} className="absolute inset-0 flex justify-center items-center text-sm">
                                    <span className={`text-primary-600 font-semibold`}>
                                      Review Your Application
                                    </span>
                                  </motion.div>}
                              </AnimatePresence>
                            </div>
                          </div>

                          <div className="w-full bg-gray-200 h-2">
                            <motion.div className="bg-mediumseagreen-200 h-2" animate={{
                      width: `${currentStep === applicationFormData.steps.length + 1 ? 100 : currentStep / (applicationFormData.steps.length + 1) * 100}%`
                    }} transition={{
                      duration: 0.5
                    }}></motion.div>
                          </div>
                          <div className="flex flex-col h-full max-h-[calc(60vh)]">
                            <div className="p-6 overflow-y-auto" ref={scrollContainerRef}>
                              <AnimatePresence mode="wait">
                                {currentStep <= applicationFormData.steps.length && <motion.div initial={{
                          opacity: 0,
                          x: 10
                        }} animate={{
                          opacity: 1,
                          x: 0
                        }} exit={{
                          opacity: 0,
                          x: -10
                        }} transition={{
                          duration: 0.3
                        }} key={`step-${currentStep}`}>
                                    <ApplicationStep setJsonSuccess={setJsonSuccess} inputValues={inputValues} setInputValues={setInputValues} stepData={applicationFormData.steps[currentStep - 1]} onValueChange={stepValue => {
                            setApplicationFormValue(stepValue);
                            //console.log(stepValue);
                          }} value={applicationFormValue[applicationFormData.steps[currentStep - 1]]} />
                                  </motion.div>}
                                {currentStep > applicationFormData.steps.length && <motion.div initial={{
                          opacity: 0,
                          x: 10
                        }} animate={{
                          opacity: 1,
                          x: 0
                        }} exit={{
                          opacity: 0,
                          x: -10
                        }} transition={{
                          duration: 0.3
                        }} key="review" // Use a unique key for the review step
                        >
                                    <ApplicationSummary steps={[{
                            "Full Name": userData.name,
                            email: userData.email,
                            address: userData.address,
                            phone: userData.phone
                          }, {
                            resume: applicationFormData.steps[1].sections[0].questions[0].options.find(option => option.index === inputValues["resumeFile"])?.title || userData.filename
                          }, Object.keys(inputValues).filter(key => !key.includes("wrangle_general") && !key.includes("resumeFile") && inputValues[key]) // Exclude keys containing "wrangle"
                          .reduce((obj, key) => {
                            const formElement = formInfo.find(element => element.label === key);
                            if (formElement && formElement.options && formElement.options.length > 0) {
                              // Find the option where the value matches inputValues[key]
                              const matchingOption = formElement.options.find(option => option.value === inputValues[key]);
                              if (matchingOption) {
                                // If a matching option is found, set the obj[key] to the label of the found option
                                obj[key] = matchingOption.label;
                              } else {
                                // If there's no matching option, keep the original inputValues[key]
                                obj[key] = inputValues[key];
                              }
                            } else {
                              // If the formElement does not exist or does not have options, keep the original inputValues[key]
                              obj[key] = inputValues[key];
                            }
                            //if(obj.value){
                            return obj;
                            //}
                          }, {})]} setCurrentStep={setCurrentStep} />
                                  </motion.div>}
                              </AnimatePresence>
                            </div>
                          </div>

                          <div className="flex items-center justify-between py-4 px-6 bg-luh-gray border-t border-gray-300 rounded-b-lg border-b border-neutral-700 border-t-[1px] box-border border-solid">
                            <div className="flex items-center text-luh-light-gray text-note">
                              <span className="mr-1">Powered by</span>
                              <motion.svg className="mt-1" width="52" height="18" viewBox="0 0 55 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.90193 9.80753C3.28725 9.80753 2.74479 9.40575 2.56562 8.81776L0.427997 1.80295C0.215073 1.10422 0.737829 0.398438 1.46828 0.398438V0.398438C1.96589 0.398438 2.40002 0.73618 2.52239 1.21851L3.96266 6.89528C3.96875 6.91929 3.99036 6.9361 4.01513 6.9361V6.9361C4.03941 6.9361 4.06072 6.91994 4.06727 6.89656L5.61924 1.35196C5.77704 0.788196 6.29087 0.398438 6.87631 0.398438V0.398438C7.46234 0.398438 7.97655 0.788981 8.13381 1.35352L9.68112 6.90798C9.68802 6.93275 9.71058 6.94988 9.73629 6.94988V6.94988C9.76251 6.94988 9.78537 6.93208 9.79181 6.90667L11.2318 1.21888C11.354 0.736386 11.7882 0.398438 12.2859 0.398438V0.398438C13.0162 0.398438 13.5389 1.10409 13.326 1.80269L11.1884 8.81739C11.0091 9.4056 10.4665 9.80753 9.85157 9.80753V9.80753C9.23923 9.80753 8.69821 9.4089 8.5168 8.82405L6.92523 3.69316C6.91834 3.67093 6.89778 3.65578 6.87451 3.65578V3.65578C6.85123 3.65578 6.83066 3.67095 6.82378 3.69319L5.23649 8.82346C5.05546 9.40857 4.51441 9.80753 3.90193 9.80753V9.80753Z" fill="#B8B8B8" />
                                <path d="M15.1443 9.80753C14.5688 9.80753 14.1022 9.34093 14.1022 8.76535V3.76109C14.1022 3.20307 14.5545 2.75071 15.1125 2.75071H15.5073C15.8473 2.75071 16.1229 3.02634 16.1229 3.36634V3.93686C16.1229 3.96178 16.1431 3.98198 16.168 3.98198V3.98198C16.1878 3.98198 16.2052 3.96911 16.2113 3.95035C16.3494 3.52804 16.576 3.20779 16.8911 2.98961C17.1783 2.78807 17.5041 2.67614 17.8686 2.65381C17.9605 2.64818 17.9797 2.64721 18.0714 2.65521V2.65521C18.3757 2.68177 18.6623 2.93446 18.6623 3.23986V3.5238C18.6623 3.95675 18.2157 4.35485 17.7827 4.34953V4.34953C17.7698 4.34938 17.7751 4.34949 17.7621 4.34961C17.4634 4.35221 17.1959 4.41497 16.9596 4.53789C16.7215 4.6604 16.5323 4.83192 16.392 5.05245C16.255 5.27297 16.1865 5.52719 16.1865 5.8151V8.76535C16.1865 9.34093 15.7199 9.80753 15.1443 9.80753V9.80753Z" fill="#B8B8B8" />
                                <path d="M21.3922 9.94076C20.9127 9.94076 20.4854 9.86266 20.1103 9.70645C19.7352 9.54719 19.4383 9.31288 19.2198 9.00353C19.0045 8.69112 18.8968 8.30214 18.8968 7.83658C18.8968 7.44454 18.9735 7.11528 19.1268 6.84881C19.2801 6.58234 19.4889 6.36794 19.7531 6.20561C20.0173 6.04328 20.3174 5.92077 20.6534 5.83807C20.9926 5.75537 21.3482 5.69718 21.72 5.66349C22.1571 5.62061 22.5094 5.58079 22.7769 5.54403C23.0444 5.50422 23.2385 5.44602 23.3591 5.36945C23.4798 5.29288 23.5402 5.17955 23.5402 5.02947V5.00191C23.5402 4.71094 23.4423 4.48582 23.2466 4.32655C23.0542 4.16728 22.7802 4.08765 22.4246 4.08765C22.0495 4.08765 21.751 4.16575 21.5292 4.32195V4.32195C21.1723 4.56837 20.7819 4.87742 20.3494 4.84444L20.3029 4.8409C19.7016 4.79504 19.2727 4.19786 19.6581 3.73394C19.684 3.70276 19.7108 3.67211 19.7384 3.642C20.0255 3.32653 20.3957 3.08456 20.8491 2.9161C21.3058 2.74458 21.8342 2.65883 22.4344 2.65883C22.8519 2.65883 23.2515 2.70477 23.6332 2.79665C24.0181 2.88854 24.3589 3.03096 24.6558 3.22392C24.9559 3.41688 25.1923 3.66497 25.3652 3.9682C25.5381 4.26835 25.6246 4.62824 25.6246 5.04785V8.81917C25.6246 9.36502 25.182 9.80753 24.6362 9.80753H24.1371C23.8669 9.80753 23.6478 9.58847 23.6478 9.31824V8.86581C23.6478 8.84545 23.6313 8.82895 23.611 8.82895V8.82895C23.5975 8.82895 23.5851 8.83631 23.5785 8.84806C23.459 9.06072 23.3011 9.24885 23.1047 9.41242C22.9025 9.57782 22.6595 9.70799 22.3757 9.80293C22.0919 9.89482 21.7641 9.94076 21.3922 9.94076ZM21.9891 8.59004C22.2958 8.59004 22.5665 8.53338 22.8014 8.42006C23.0362 8.30367 23.2205 8.14746 23.3543 7.95144C23.488 7.75542 23.5549 7.53336 23.5549 7.28527V6.828C23.5549 6.70024 23.4083 6.6105 23.2858 6.64666V6.64666C23.1749 6.67729 23.0493 6.70639 22.909 6.73395C22.7687 6.75846 22.6285 6.78143 22.4882 6.80287C22.348 6.82125 22.2207 6.83809 22.1066 6.85341C21.8619 6.8871 21.6483 6.9407 21.4656 7.01421C21.2829 7.08771 21.141 7.18726 21.0399 7.31283C20.9388 7.43535 20.8882 7.58849 20.8882 7.77226C20.8882 8.03873 20.991 8.24241 21.1965 8.3833C21.4053 8.52113 21.6695 8.59004 21.9891 8.59004Z" fill="#B8B8B8" />
                                <path d="M29.0505 5.72781V8.76534C29.0505 9.34093 28.5838 9.80753 28.0083 9.80753V9.80753C27.4327 9.80753 26.9661 9.34093 26.9661 8.76534V3.74397C26.9661 3.19541 27.4108 2.75071 27.9593 2.75071H28.3301C28.6739 2.75071 28.9526 3.02942 28.9526 3.37324V3.94314C28.9526 3.9722 28.9762 3.99576 29.0052 3.99576V3.99576C29.0266 3.99576 29.0459 3.98273 29.0543 3.96301C29.222 3.56803 29.4964 3.25428 29.8773 3.02177C30.2688 2.77981 30.7434 2.65883 31.3012 2.65883C31.8231 2.65883 32.2781 2.76602 32.6663 2.98042C33.0545 3.19482 33.3562 3.50111 33.5715 3.89928C33.7868 4.29439 33.8944 4.76607 33.8944 5.31432V8.76534C33.8944 9.34093 33.4278 9.80753 32.8522 9.80753V9.80753C32.2766 9.80753 31.81 9.34093 31.81 8.76534V5.66349C31.8133 5.23162 31.6959 4.89471 31.4577 4.65274C31.2196 4.40772 30.8918 4.2852 30.4743 4.2852C30.1938 4.2852 29.9458 4.34186 29.7306 4.45519C29.5185 4.56851 29.3522 4.73391 29.2315 4.95137C29.1141 5.16577 29.0537 5.42458 29.0505 5.72781Z" fill="#B8B8B8" />
                                <path d="M38.6475 12.6009C37.9723 12.6009 37.3933 12.5136 36.9105 12.339C36.431 12.1675 36.0494 11.9332 35.7656 11.6361V11.6361C35.3402 11.1907 35.7428 10.5675 36.3538 10.4904L36.6573 10.452C36.9427 10.416 37.2121 10.5865 37.4194 10.7861V10.7861C37.5466 10.9086 37.7146 11.0066 37.9233 11.0801C38.1354 11.1567 38.3931 11.195 38.6964 11.195C39.1498 11.195 39.5233 11.0909 39.8169 10.8826C40.1137 10.6774 40.2621 10.3328 40.2621 9.84888V8.61168C40.2621 8.58197 40.2381 8.55788 40.2084 8.55788V8.55788C40.1874 8.55788 40.1685 8.57003 40.1592 8.58879C40.0682 8.77341 39.9361 8.94841 39.7631 9.11379C39.5804 9.28838 39.3455 9.4308 39.0585 9.54106C38.7714 9.65132 38.4289 9.70645 38.031 9.70645C37.4667 9.70645 36.9529 9.58394 36.4897 9.33891C36.0298 9.09082 35.6628 8.71256 35.3888 8.20412C35.1181 7.69263 34.9827 7.04636 34.9827 6.26534C34.9827 5.46593 35.1214 4.79823 35.3986 4.26223C35.6759 3.72623 36.0445 3.325 36.5044 3.05853C36.9676 2.79206 37.4748 2.65883 38.0261 2.65883C38.4469 2.65883 38.7992 2.72621 39.083 2.86097C39.3667 2.99268 39.5951 3.15807 39.768 3.35716C39.9359 3.54401 40.0667 3.72807 40.1605 3.90936C40.169 3.92565 40.1857 3.93604 40.204 3.93604V3.93604C40.2307 3.93604 40.2524 3.91439 40.2524 3.88768V3.34337C40.2524 3.01605 40.5177 2.75071 40.845 2.75071H41.2872C41.8587 2.75071 42.322 3.21403 42.322 3.78555V9.87644C42.322 10.4768 42.1655 10.9791 41.8523 11.3834C41.5392 11.7877 41.1053 12.0909 40.5508 12.293C39.9996 12.4982 39.3651 12.6009 38.6475 12.6009ZM38.6915 8.23628C39.0275 8.23628 39.3113 8.15818 39.5429 8.00198C39.7777 7.84271 39.9572 7.61606 40.0811 7.32202C40.2083 7.02492 40.2719 6.66963 40.2719 6.25615C40.2719 5.84266 40.21 5.48431 40.086 5.18109C39.962 4.8748 39.7826 4.63743 39.5478 4.46897C39.3129 4.30052 39.0275 4.21629 38.6915 4.21629C38.349 4.21629 38.0603 4.30358 37.8255 4.47816C37.5906 4.64968 37.4129 4.88858 37.2922 5.19487C37.1715 5.50115 37.1111 5.85491 37.1111 6.25615C37.1111 6.66351 37.1715 7.01574 37.2922 7.31283C37.4161 7.60687 37.5939 7.83505 37.8255 7.99738C38.0603 8.15665 38.349 8.23628 38.6915 8.23628Z" fill="#B8B8B8" />
                                <path d="M44.7473 0.398438C45.3229 0.398438 45.7895 0.865039 45.7895 1.44062V8.76534C45.7895 9.34093 45.3229 9.80753 44.7473 9.80753V9.80753C44.1718 9.80753 43.7052 9.34093 43.7052 8.76534V1.44062C43.7052 0.86504 44.1718 0.398438 44.7473 0.398438V0.398438Z" fill="#B8B8B8" />
                                <path d="M50.6087 9.94536C49.8356 9.94536 49.1702 9.79834 48.6124 9.50431C48.0579 9.20721 47.6305 8.7876 47.3304 8.24547C47.0304 7.70028 46.8803 7.05555 46.8803 6.31128C46.8803 5.58538 47.0304 4.94831 47.3304 4.40006C47.6305 3.85181 48.053 3.42454 48.5977 3.11825C49.1457 2.81197 49.7883 2.65883 50.5255 2.65883C51.0213 2.65883 51.4829 2.73386 51.9102 2.88394C52.3408 3.03096 52.7159 3.25302 53.0355 3.55012C53.3585 3.84721 53.6096 4.22088 53.789 4.67112C53.9685 5.1183 54.0582 5.64205 54.0582 6.24237V6.24237C54.0582 6.53924 53.8175 6.7799 53.5206 6.7799H48.3185C47.9836 6.7799 47.7121 6.50838 47.7121 6.17345V6.17345C47.7121 5.83852 47.9836 5.56701 48.3185 5.56701H51.3124C51.7452 5.56701 52.1231 5.18931 51.9004 4.81814V4.81814C51.7699 4.60067 51.5889 4.43069 51.3573 4.30817C51.129 4.1826 50.8631 4.11981 50.5597 4.11981C50.2433 4.11981 49.9628 4.18872 49.7182 4.32655C49.4768 4.46132 49.2876 4.64355 49.1506 4.87327C49.0136 5.09992 48.9435 5.35261 48.9402 5.63133V6.78449C48.9402 7.13366 49.0087 7.43535 49.1457 7.68956C49.286 7.94378 49.4833 8.1398 49.7377 8.27763C49.9922 8.41546 50.2939 8.48438 50.6429 8.48438C50.8745 8.48438 51.0865 8.45375 51.279 8.39249C51.4715 8.33123 51.6362 8.23935 51.7732 8.11683V8.11683C52.0195 7.89655 52.3088 7.68038 52.6386 7.70081L52.8197 7.71203C53.4462 7.75086 53.8932 8.36933 53.484 8.84541C53.4608 8.87245 53.4369 8.89912 53.4123 8.92543C53.1122 9.24703 52.724 9.49818 52.2478 9.67889C51.7748 9.85653 51.2284 9.94536 50.6087 9.94536Z" fill="#B8B8B8" />
                              </motion.svg>
                              <span className="mx-2 h-4 border-l-[1px] border-solid border-neutral-700"></span>
                              <a href="https://wranglejobs.com" className="mr-2 text-luh-light-gray hover:text-luh-light-gray focus:text-luh-light-gray active:text-luh-light-gray no-underline" target="_blank" rel="noopener noreferrer">
                                Website
                              </a>
                              <a href="https://wranglejobs.com/companies" className="text-luh-light-gray hover:text-luh-light-gray focus:text-luh-light-gray active:text-luh-light-gray no-underline" target="_blank" rel="noopener noreferrer">
                                Companies
                              </a>
                            </div>
                            <div className="flex">
                              <button onClick={prevStep} className={`mr-4 py-3 px-6 rounded-md border-neutral-600 border-[1px] border-solid bg-base-white text-primary-600 font-sm ${currentStep === 1 ? "opacity-0 cursor-default" : "hover:bg-neutral-50"}`}>
                                Back
                              </button>
                              <button onClick={currentStep === applicationFormData.steps.length + 1 ? handleSubmit : nextStep} disabled={currentStep == applicationFormData.steps.length && !isFormReady && !htmlId} className={`py-3 px-6 rounded-md text-sm font-sm ${currentStep != applicationFormData.steps.length || currentStep === applicationFormData.steps.length && isFormReady && !htmlId || htmlId ? "bg-mediumseagreen-200 text-base-white hover:bg-green-300 cursor-pointer" : "bg-gray-200 text-gray-500 cursor-not-allowed"}`}>
                                {currentStep === applicationFormData.steps.length + 1 ? "Submit" : "Next"}
                              </button>
                            </div>
                          </div>
                        </> : <div className="flex items-center justify-center h-[400px] w-[400px] min-h-[400px] min-w-[100%]">
                          <Loader />
                        </div>}
                    </div>
                  </>}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>}
    </AnimatePresence>;
};
export default AppModal;